import React from 'react';

interface ResursMediaConfigurationProps {
    configuration: {
        Login?: string;
        Password?: string;
        WarehouseId?: string;
        Warehouses?: string;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface ResursMediaConfigurationComponent extends React.FC<ResursMediaConfigurationProps> {
    configFields: string[];
}

const ResursMediaConfiguration: ResursMediaConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">👤</span>
                    Логин
                </label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={configuration.Login || ''}
                        onChange={(e) => onChange('Login', e.target.value)}
                        placeholder="Введите логин"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🔒</span>
                    Пароль
                </label>
                <div className="input-group-custom">
                    <input
                        type="password"
                        className="form-input-custom"
                        value={configuration.Password || ''}
                        onChange={(e) => onChange('Password', e.target.value)}
                        placeholder="Введите пароль"
                        disabled={disabled}
                        autoComplete='new-password'
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🏢</span>
                    Warehouse ID
                </label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={configuration.WarehouseId || ''}
                        onChange={(e) => onChange('WarehouseId', e.target.value)}
                        placeholder="Идентификатор склада"
                        disabled={disabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
ResursMediaConfiguration.configFields = ['Login', 'Password', 'WarehouseId'];

export default ResursMediaConfiguration;
